import { createGlobalStyle } from 'styled-components';



const GlobalStyles = createGlobalStyle`
  /* 🎨 Define Brand Colors */
  :root {
    --main-orange: #FF7C24;
    --main-black: #232830;
    --main-white: #FFFFFF;

    /* 🖋 Typography - Font Family */
    --font-primary: 'Nunito Sans', sans-serif;

    /* 🔠 Display Styles */
    --display-large: 34px;
    --display-medium: 28px;
    --display-small: 24px;

    /* 🔠 Title Styles */
    --title1-size: 22px;
    --title2-size: 20px;
    --title3-size: 18px;

    /* 🔠 Body Text Styles */
    --headline-size: 17px;
    --body-size: 17px;
    --callout-size: 16px;
    --subhead-size: 15px;
    --footnote-size: 13px;
    --caption1-size: 12px;
    --caption2-size: 10px;

    /* 🔠 Button & Form Styles */
    --button-text-size: 16px;
    --field-label-size: 16px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: var(--font-primary);
    color: var(--main-black);
    background-color: var(--main-white);
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6, p, a {
    border-radius: 0;
    padding: 0;
  }

  .rounded-text {
    border-radius: 12px;
    padding: 8px 14px;
    background-color: rgba(255, 124, 36, 0.08);
    display: inline-block;
  }

  h1 {
    font-size: var(--display-large);
    font-weight: bold;
    color: var(--main-orange);
    border-radius: 14px;
    padding: 10px;
  }

  h2 {
    font-size: var(--display-medium);
    font-weight: bold;
    color: var(--main-orange);
    border-radius: 12px;
    padding: 8px;
  }

  h3 {
    font-size: var(--display-small);
    font-weight: bold;
    color: var(--main-black);
    border-radius: 10px;
    padding: 6px;
  }

  p {
    font-size: var(--body-size);
    font-weight: 400;
    line-height: 1.5;
    color: var(--main-black);
    border-radius: 10px;
    padding: 6px 12px;
    background-color: rgba(255, 124, 36, 0.1);
  }

  a {
    font-size: var(--body-size);
    text-decoration: none;
    color: var(--main-orange);
    font-weight: 600;
    transition: all 0.3s ease;
    border-radius: 10px;
    padding: 6px 10px;
  }

  a:hover {
    text-decoration: underline;
    color: var(--main-black);
    background-color: rgba(255, 124, 36, 0.15);
    border-radius: 12px;
  }

  button {
    font-size: var(--button-text-size);
    font-weight: bold;
    color: var(--main-white);
    background-color: var(--main-orange);
    border: none;
    padding: 14px 28px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
  }

  button:hover {
    background-color: var(--main-black);
  }

  label {
    font-size: var(--field-label-size);
    font-weight: 400;
    color: var(--main-black);
    display: block;
    border-radius: 8px;
    padding: 4px;
  }

  input, textarea {
    font-size: var(--field-label-size);
    font-weight: 400;
    padding: 14px;
    border: 2px solid rgba(255, 124, 36, 0.6);
    border-radius: 16px;
    width: 100%;
    margin-top: 5px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    background-color: rgba(35, 40, 48, 0.03);
  }

  input:focus, textarea:focus {
    outline: none;
    border-color: var(--main-orange);
    box-shadow: 0px 0px 8px rgba(255, 124, 36, 0.4);
  }

  .rounded-container {
    border-radius: 16px;
    padding: 20px;
    background-color: rgba(35, 40, 48, 0.05);
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
  }

  .text-center {
    text-align: center;
  }

  .text-bold {
    font-weight: bold;
  }

  .rounded-text {
    border-radius: 12px;
    padding: 6px 10px;
    background-color: rgba(255, 124, 36, 0.1);
  }

  .form-error {
    font-size: var(--footnote-size);
    color: var(--main-orange);
    text-align: center;
    margin-top: 6px;
  }

  .form-success {
    font-size: var(--footnote-size);
    color: #28a745;
    text-align: center;
    margin-top: 6px;
  }

  .helper-text {
    font-size: var(--caption1-size);
    color: #6c757d;
    margin-top: 4px;
    text-align: left;
  }


 


  /* ---- Activation full-bleed shell (dark, no white bands) ---- */
  html, body, #root {
    /* baseline reset to avoid gaps on some browsers */
    min-height: 100%;
  }

  body.ft-activation, 
  body.ft-activation #root {
    /* Use dynamic viewport height to handle mobile browser UI */
    min-height: 100dvh;
    background-color: #0B0D11 !important;  /* override site white */
    color: #DDE2EA;
    margin: 0;          /* ensure no default margins */
  }

  /* Prevent accidental page scroll bounce from creating bands */
  body.ft-activation {
    overscroll-behavior-y: none;
  }


  
/* Fix react-date-picker text color */
.react-date-picker__inputGroup input,
.react-date-picker__inputGroup span {
  color: #ffffff !important;
}

.react-calendar {
  background: #1c1f22 !important;
  color: #ffffff !important;
  border: 1px solid #333 !important;
}

.react-calendar__tile {
  color: #ffffff !important;
}

.react-calendar__navigation button {
  color: #ffffff !important;
  background: #1f1f1f !important;
}

.react-calendar__month-view__weekdays__weekday {
  color: #d0d0d0 !important;
}

.react-calendar__tile--active {
  background: #4dabf7 !important;
  color: #000 !important;
}

.react-calendar__tile--now {
  background: #fffa90 !important;
  color: #000 !important;
}








`;

export default GlobalStyles;